import classNames from "classnames";
import styles from "./Content.module.css";
import { type PropsWithChildren, type JSX } from "react";

type ContentProps = PropsWithChildren<{
  background?: "default" | "gray";
  withPadding?: boolean;
  withLargePadding?: boolean;
  withMargin?: boolean;
  isCentered?: boolean;
  reducedGap?: boolean;
  className?: string;
}>;

const Content = (props: ContentProps): JSX.Element => {
  const {
    children,
    background = "default",
    withPadding = false,
    withLargePadding = false,
    withMargin = false,
    isCentered = false,
    reducedGap = false,
    className,
  } = props;

  const contentClassNames = classNames(
    styles.content,
    {
      [styles[background]]: background !== "default",
      [styles.withPadding]: withPadding,
      [styles.withLargePadding]: withLargePadding,
      [styles.withMargin]: withMargin,
      [styles.isCentered]: isCentered,
      [styles.reducedGap]: reducedGap,
    },
    className,
  );

  return <div className={contentClassNames}>{children}</div>;
};

export { Content };
